// import React, { useState, useEffect } from 'react';
// import AddBtn from "../../Assets/addIcon.png"
// import RemoveBtn from "../../Assets/removeIcon.png"
// import { useDispatch, useSelector } from "react-redux";
// import { addItem, removeItem, addItemToCart, removeItemToCart } from '../../redux/action';
// import SizeSelector from '../SizeSelector';


// const SelectItem = ({ menuId, tab, unit, isAvailable, menuSizeOptions, onSizeSelect, selectedSize: propsSelectedSize, tableName })  => {
//     const cart = useSelector((state) => state?.user?.cart);
//     // Initialize from propsSelectedSize, unit.selectedSize, or null
//     const [selectedSize, setSelectedSize] = useState(propsSelectedSize || unit?.selectedSize || null);
//       console.log("unit on selectetem", unit)
//     const dispatch = useDispatch()
    
//     // Sync selectedSize with prop from ListItem or from unit (cart item)
//     useEffect(() => {
//         setSelectedSize(propsSelectedSize || unit?.selectedSize || null);
//     }, [propsSelectedSize, unit?.selectedSize]);
    
//     const handleSizeSelect = (size) => {
//         console.log("selected size", size);
//         setSelectedSize(size);
//         if (onSizeSelect) {
//             onSizeSelect(size);
//         }
//     };

//     const handleIncrement = () => {
//         console.log("menuId", menuId)
//         console.log("tab", tab)
//         console.log("selectedSize", selectedSize)
//         // 🌟 BADLAAV 2: Action payload ke andar 'tableName' pass kiya
//         dispatch(addItemToCart({ menuId: menuId, selectedTab: tab, selectedSize: selectedSize, tableName: tableName }));
//     };

//     const handleDecrement = () => {
//         console.log("menuId", menuId)
//         console.log("tab", tab)
//         console.log("selectedSize", selectedSize)
//         // 🌟 BADLAAV 3: Action payload ke andar 'tableName' pass kiya
//         dispatch(removeItemToCart({ menuId: menuId, selectedTab: tab, selectedSize: selectedSize, tableName: tableName }));
//     };

//     // Show size selector if size options are available
//     const hasSizeOptions = menuSizeOptions && menuSizeOptions.length > 0;

//     return (isAvailable ?
//         <div className="select-item-container">
//             <div className="add-remove-controls">
//                 <img src={AddBtn} title="" alt="" className="addRemoveIcon" onClick={handleIncrement} />
//                 {unit && <div className="selectNum">
//                     <div>{unit.selected}</div>
//                 </div>}
//                 {unit  && <img src={RemoveBtn} title="" alt="" className="addRemoveIcon" onClick={handleDecrement} />}
//             </div>
//             {hasSizeOptions && (
//                 <SizeSelector 
//                     menuSizeOptions={menuSizeOptions}
//                     onSizeSelect={handleSizeSelect}
//                     selectedSize={selectedSize}
//                 />
//             )}
//         </div>
//         :
//         null
//     );
// };

// export default SelectItem;
//----------------------------------------------------------------------------------------------------
// import React, { useState } from "react";
// import AddBtn from "../../Assets/addIcon.png";
// import RemoveBtn from "../../Assets/removeIcon.png";
// import { useDispatch } from "react-redux";
// import { addItemToCart, removeItemToCart } from "../../redux/action";
// import ItemCustomizationModal from "./ItemCustomizationModal";

// const SelectItem = ({
//   menuId,
//   tab,
//   unit,
//   isAvailable,
//   menuSizeOptions,
//   tableName,
//   rawItem, // Full item object passed from ListItem
// }) => {
//   const dispatch = useDispatch();
//   const [isModalOpen, setIsModalOpen] = useState(false);

//   // Check if item has sizes or add-ons
//   const hasVariants = menuSizeOptions && menuSizeOptions.length > 0;
//   const isCustomizable = hasVariants || rawItem?.hasAddons;

//   const handleIncrement = () => {
//     if (isCustomizable) {
//       // Open modal to configure size + add-ons
//       setIsModalOpen(true);
//     } else {
//       // Direct add for simple items
//       dispatch(
//         addItemToCart({
//           menuId: menuId,
//           selectedTab: tab,
//           tableName: tableName,
//           price: rawItem?.price,
//           foodName: rawItem?.foodName || rawItem?.name,
//         })
//       );
//     }
//   };

//   const handleDecrement = () => {
//     if (unit) {
//       dispatch(
//         removeItemToCart({
//           cartKey: unit.cartKey,
//           menuId: menuId,
//           tableName: tableName,
//         })
//       );
//     }
//   };

//   const handleModalAdd = (customizedData) => {
//     dispatch(addItemToCart(customizedData));
//   };

//   if (!isAvailable) return null;

//   return (
//     <div className="select-item-container">
//       <div className="add-remove-controls">
//         <img
//           src={AddBtn}
//           alt="Add"
//           className="addRemoveIcon"
//           onClick={handleIncrement}
//         />
//         {unit && (
//           <div className="selectNum">
//             <div>{unit.selected}</div>
//           </div>
//         )}
//         {unit && (
//           <img
//             src={RemoveBtn}
//             alt="Remove"
//             className="addRemoveIcon"
//             onClick={handleDecrement}
//           />
//         )}
//       </div>

//       {isCustomizable && (
//         <span
//           style={{ fontSize: "10px", color: "#ea580c", display: "block", textAlign: "center", cursor: "pointer" }}
//           onClick={() => setIsModalOpen(true)}
//         >
//           Customise
//         </span>
//       )}

//       {/* Customization Modal */}
//       <ItemCustomizationModal
//         isOpen={isModalOpen}
//         onClose={() => setIsModalOpen(false)}
//         item={rawItem || { menuId, menuSizeOptions }}
//         tabId={tab}
//         tableName={tableName}
//         onAddToCart={handleModalAdd}
//       />
//     </div>
//   );
// };

// export default SelectItem;

//----------------------------------------------------------------------------------------------------

import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { addItemToCart, removeItemToCart } from "../../redux/action";
import ItemCustomizationModal from "./ItemCustomizationModal";
import { isOrderAvailable } from "../../Utills/menuAvailability";

const SelectItem = ({
  menuId,
  tab,
  unit,
  isAvailable,
  menuSizeOptions,
  tableName,
  rawItem,
  respectSchedule = false,
}) => {
  const dispatch = useDispatch();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const hasVariants = menuSizeOptions && menuSizeOptions.length > 0;
  const isCustomizable = hasVariants || rawItem?.hasAddons;

  const canAdd = () => respectSchedule ? isOrderAvailable(rawItem, isAvailable) : Boolean(isAvailable);

  const handleIncrement = () => {
    if (!canAdd()) return;
    // Agar customizable hai aur pehli baar add ho raha hai, toh modal open karein
    if (isCustomizable && (!unit || unit.selected === 0)) {
      setIsModalOpen(true);
    } else if (unit && unit.cartKey) {
      // Cart mein already configured item ki quantity seedha increase karein
      dispatch(
        addItemToCart({
          cartKey: unit.cartKey,
          menuId: menuId,
          selectedTab: tab,
          tableName: tableName,
          price: unit.price,
          foodName: unit.name || rawItem?.foodName,
          selectedSize: unit.selectedSize,
          selectedAddons: unit.selectedAddons,
        })
      );
    } else {
      // Plain item direct add
      dispatch(
        addItemToCart({
          menuId: menuId,
          selectedTab: tab,
          tableName: tableName,
          price: rawItem?.price || 0,
          foodName: rawItem?.foodName || rawItem?.name,
        })
      );
    }
  };

  const handleDecrement = () => {
    if (unit) {
      dispatch(
        removeItemToCart({
          cartKey: unit.cartKey,
          menuId: menuId,
          tableName: tableName,
        })
      );
    }
  };

  const handleModalAdd = (customizedData) => {
    if (!canAdd()) { setIsModalOpen(false); return; }
    dispatch(addItemToCart(customizedData));
  };

  if (!canAdd()) return null;

  const hasQuantity = unit && unit.selected > 0;

  return (
    <div className="select-item-container" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <div 
        className="add-remove-controls"
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          // background: hasQuantity ? "#f8fafc" : "transparent",
          padding: hasQuantity ? "2px 6px" : "0",
          borderRadius: "6px",
          // border: hasQuantity ? "1px solid #e2e8f0" : "none"
        }}
      >
        {/* Minus button tabhi dikhega jab item already cart me ho */}
        
         {/* Plus / Add button */}
        <button
          type="button"
          aria-label="Add item"
          className="quantity-button"
          onClick={handleIncrement}
        >+</button>
        
        {/* Quantity display */}
        {hasQuantity && (
          <div className="selectNum" style={{ minWidth: "18px", textAlign: "center", fontWeight: "600", fontSize: "14px" }}>
            {unit.selected}
          </div>
        )}

       
        {hasQuantity && (
          <button
            type="button"
            aria-label="Remove item"
            className="quantity-button"
            onClick={handleDecrement}
          >−</button>
        )}
      </div>

      {/* Customizable indicator / link */}
      {isCustomizable && (
        <span
          style={{
            fontSize: "11px",
            color: "#ea580c",
            display: "block",
            textAlign: "center",
            cursor: "pointer",
            marginTop: "3px",
            fontWeight: "500"
          }}
          onClick={() => { if (canAdd()) setIsModalOpen(true); }}
        >
          {hasQuantity ? "Customise +" : "Customise"}
        </span>
      )}

      {/* Customization Modal */}
      <ItemCustomizationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        item={rawItem || { menuId, menuSizeOptions }}
        tabId={tab}
        tableName={tableName}
        onAddToCart={handleModalAdd}
      />
    </div>
  );
};

export default SelectItem;
